import styled from 'styled-components';
import Button from '../../Button';
export var Title = styled.div.withConfig({
  displayName: "elements__Title",
  componentId: "sc-188e6sd-0"
})(["flex:1;user-select:none;font-weight:", ";font-size:", ";"], function (_ref) {
  var fonts = _ref.theme.fonts;
  return fonts.weight.thick;
}, function (_ref2) {
  var fonts = _ref2.theme.fonts;
  return fonts.size.medium;
});
export var HeaderButton = styled(Button).withConfig({
  displayName: "elements__HeaderButton",
  componentId: "sc-188e6sd-1"
})(["padding:0;"]);